import ReducerUtils         from "../../../utils/ReducerUtils"
import Actions              from "../../../model/constant/actions"

const creatingNewAdGroup = ReducerUtils.createReducer(false,{
  [Actions.CREATING_NEW_ADGROUP] : (state,action) => action.status
})

export default creatingNewAdGroup
